export default {
    title: 'AI Prompts',
    hint: 'Επίλεξε ένα prompt, αντίγραψέ το και επικόλλησέ το στον AI assistant σου.',
    empty: 'Δεν υπάρχουν prompts εδώ',
    emptyText: 'Τα διαθέσιμα prompts αλλάζουν ανάλογα με την οθόνη στην οποία βρίσκεσαι.',
    copy: 'Αντιγραφή',
    copied: 'Αντιγράφηκε!',
    triggerTooltip: 'AI Prompts',

    // Προστίθεται μόνο στο αντιγραμμένο κείμενο (κρυφό από την προεπισκόπηση).
    // Η παραλλαγή "Client" χρησιμοποιείται όταν η οθόνη έχει πελάτη σε context.
    copyContext: 'Χρησιμοποίησε τα δεδομένα μου από το Athlisis.',
    copyContextClient: 'Χρησιμοποίησε τα δεδομένα μου από το Athlisis για τον πελάτη με ID {{athleteId}}.',

    contexts: {
        practice: {
            label: 'Πρόγραμμα & πελάτες',
            items: [
                {
                    slug: 'home-today',
                    title: 'Σύνοψη ημέρας',
                    body: 'Προετοίμασέ με για σήμερα: ραντεβού, πελάτες και ό,τι πρέπει να προσέξω.',
                },
                {
                    slug: 'home-week-overview',
                    title: 'Εβδομαδιαία επισκόπηση',
                    body: 'Δείξε μου τα ραντεβού της εβδομάδας και ποια μέρα είναι η πιο απαιτητική.',
                },
                {
                    slug: 'appt-occupancy-compare',
                    title: 'Σύγκριση πληρότητας',
                    body: 'Πόσο γεμάτο είναι το πρόγραμμά μου αυτή την εβδομάδα συγκριτικά με την προηγούμενη;',
                },
                {
                    slug: 'appt-revenue',
                    title: 'Έσοδα ημέρας / εβδομάδας',
                    body: 'Με βάση τα ραντεβού, ποια τα συνολικά έσοδα σήμερα / αυτή την εβδομάδα;',
                },
                {
                    slug: 'home-week-priorities',
                    title: 'Προτεραιότητες εβδομάδας',
                    body: 'Βάσει των ραντεβού και των πελατών μου αυτή την εβδομάδα, ποιες είναι οι 3 κύριες προτεραιότητες;',
                },
                {
                    slug: 'home-quick-prep',
                    title: 'Γρήγορη προετοιμασία',
                    body: 'Δείξε μου σύντομη σύνοψη για κάθε πελάτη που έχω σήμερα: στόχοι, τελευταία μέτρηση, σχόλια.',
                },
                {
                    slug: 'appt-new-clients',
                    title: 'Ραντεβού νέων πελατών',
                    body: 'Ποια ραντεβού αυτής της εβδομάδας είναι πρώτες συνεδρίες με νέους πελάτες; Τι να ξέρω και τι να προετοιμάσω;',
                },
                {
                    slug: 'home-new-client-briefing',
                    title: 'Briefing νέου πελάτη',
                    body: 'Έχω νέο πελάτη σήμερα. Δείξε μου το προφίλ του/της και τι να ρωτήσω στην πρώτη συνεδρία.',
                },
                {
                    slug: 'appt-session-prep',
                    title: 'Προετοιμασία συνεδρίας',
                    body: 'Ετοίμασέ με για τα αυριανά ραντεβού: μετρήσεις, πλάνο και πρόσφατα σχόλια για κάθε πελάτη.',
                },
                {
                    slug: 'appt-post-session-notes',
                    title: 'Σχόλια μετά τη συνεδρία',
                    body: 'Γράψε σχόλια συνεδρίας για τον/την [όνομα πελάτη] βάσει: [σύντομη περιγραφή τι συζητήθηκε].',
                },
                {
                    slug: 'appt-recheck-reminder',
                    title: 'Υπενθύμιση επανελέγχου',
                    body: 'Φτιάξε μήνυμα υπενθύμισης για επανέλεγχο για τον/την [όνομα πελάτη].',
                },
                {
                    slug: 'appt-clients-without',
                    title: 'Πελάτες χωρίς ραντεβού',
                    body: 'Ποιοι πελάτες δεν έχουν κλείσει ραντεβού τους τελευταίους 2 μήνες;',
                },
                {
                    slug: 'appt-end-of-day',
                    title: 'Αυτόματη σύνοψη ημέρας',
                    body: 'Στο τέλος της ημέρας, δώσε μου σύνοψη: τι έγινε, τι έμεινε, τι να κλείσω αύριο.',
                },
            ],
        },

        athlete: {
            label: 'Προφίλ πελάτη',
            items: [
                {
                    slug: 'athlete-profile-summary',
                    title: 'Σύνοψη προφίλ',
                    body: 'Δείξε μου σύνοψη του προφίλ του πελάτη: υγεία, φάρμακα, στόχοι.',
                },
                {
                    slug: 'athlete-questionnaire-analysis',
                    title: 'Ανάλυση ερωτηματολογίου',
                    body: 'Ανάλυσε το ερωτηματολόγιο του πελάτη και επισήμανε τα σημαντικά σημεία για το διαιτολόγιο.',
                },
                {
                    slug: 'athlete-dietary-warnings',
                    title: 'Διατροφικές προειδοποιήσεις',
                    body: 'Βάσει του ιστορικού υγείας του πελάτη, ποιες διατροφικές προσαρμογές χρειάζονται;',
                },
                {
                    slug: 'athlete-meds-nutrition',
                    title: 'Φάρμακα & διατροφή',
                    body: 'Με βάση τα φάρμακα που παίρνει ο πελάτης, επηρεάζουν τη διατροφή του/της; Τι να προσέξω;',
                },
                {
                    slug: 'athlete-full-file-read',
                    title: 'Πλήρης ανάγνωση φακέλου',
                    body: 'Διάβασε όλα τα στοιχεία του φακέλου του πελάτη και δώσε μου ένα executive summary.',
                },
                {
                    slug: 'athlete-risk-detection',
                    title: 'Εντοπισμός κινδύνων',
                    body: 'Βάσει ηλικίας, παθήσεων και φαρμάκων του πελάτη, ποιες οι κυριότερες διατροφικές αντενδείξεις;',
                },
                {
                    slug: 'athlete-update-notes',
                    title: 'Επικαιροποίηση σχολίων',
                    body: 'Βάσει της τελευταίας συνεδρίας, γράψε ενημερωμένο σχόλιο για τον φάκελο του πελάτη.',
                },
                {
                    slug: 'athlete-history',
                    title: 'Ιστορικό αλλαγών πελάτη',
                    body: 'Δείξε μου πώς έχει εξελιχθεί ο πελάτης από την πρώτη μέρα μέχρι σήμερα: μετρήσεις, σχόλια και στόχοι.',
                },
                {
                    slug: 'athlete-drug-nutrient',
                    title: 'Αλληλεπιδράσεις φαρμάκων-θρεπτικών',
                    body: 'Με βάση τα φάρμακα του πελάτη, υπάρχουν θρεπτικά συστατικά που πρέπει να ενισχύσω ή να αποφύγω;',
                },
                {
                    slug: 'athlete-letter',
                    title: 'Έγγραφο πελάτη (.docx)',
                    body: 'Δημιούργησε ένα επαγγελματικό έγγραφο Word (.docx) στα ελληνικά με πλήρη ανάλυση του προφίλ του πελάτη, κατάλληλο να δοθεί απευθείας σε αυτόν/ή. Να περιλαμβάνει: στοιχεία πελάτη, ιατρικό ιστορικό, φαρμακευτική αγωγή, διατροφική αξιολόγηση, συνήθειες, άσκηση, στόχους και ερωτήματα πρώτης συνεδρίας.',
                },
            ],
        },

        athleteMeasurements: {
            label: 'Μετρήσεις',
            items: [
                {
                    slug: 'measurements-weight-progress',
                    title: 'Πρόοδος βάρους',
                    body: 'Δείξε μου την πρόοδο μετρήσεων του πελάτη: βάρος, λίπος, μυϊκή μάζα.',
                },
                {
                    slug: 'measurements-compare',
                    title: 'Σύγκριση μετρήσεων',
                    body: 'Σύγκρινε τις μετρήσεις του πελάτη από τον πρώτο έλεγχο με τον τελευταίο.',
                },
                {
                    slug: 'measurements-progress-note',
                    title: 'Σχόλιο προόδου',
                    body: 'Βάσει των μετρήσεων του πελάτη, γράψε σχόλιο προόδου.',
                },
                {
                    slug: 'measurements-body-composition',
                    title: 'Ανάλυση σύστασης σώματος',
                    body: 'Πώς έχει εξελιχθεί το λίπος σε σχέση με τη μυϊκή μάζα του πελάτη τους τελευταίους 3 μήνες;',
                },
                {
                    slug: 'measurements-appointment-summary',
                    title: 'Σύνοψη για ραντεβού',
                    body: 'Ετοίμασε σύνοψη των τελευταίων μετρήσεων του πελάτη για το επόμενο ραντεβού.',
                },
                {
                    slug: 'measurements-visualize',
                    title: 'Οπτικοποίηση προόδου',
                    body: 'Δώσε μου μια καθαρή σύνοψη της προόδου του πελάτη που μπορώ να του/της δείξω στη συνεδρία, με βάση όλα τα δεδομένα.',
                },
                {
                    slug: 'measurements-rate',
                    title: 'Ρυθμός απώλειας/αύξησης',
                    body: 'Είναι υγιής και ασφαλής ο ρυθμός μεταβολής βάρους του πελάτη με βάση τις τελευταίες μετρήσεις;',
                },
            ],
        },

        athleteMealLog: {
            label: 'Καταγραφή γευμάτων',
            items: [
                {
                    slug: 'meallog-evaluation',
                    title: 'Αξιολόγηση καταγραφών',
                    body: 'Αξιολόγησε τις καταγραφές των τελευταίων 2 εβδομάδων του πελάτη και πες μου τι πρέπει να προσέξει ώστε να έχει καλύτερη θρέψη, συμμόρφωση και διατροφικό μεσογειακό σκορ, και δώσε μου 5 βασικούς στόχους για βελτίωση.',
                },
                {
                    slug: 'meallog-plan-compliance',
                    title: 'Συμμόρφωση με πλάνο',
                    body: 'Αξιολόγησε αν ο πελάτης ακολουθεί το τελευταίο πλάνο βάσει των καταγεγραμμένων γευμάτων.',
                },
                {
                    slug: 'meallog-timing-pattern',
                    title: 'Μοτίβο ωραρίου',
                    body: 'Ανάλυσε το ωράριο γευμάτων του πελάτη: παραλείψεις, ακανόνιστες ώρες, κενά.',
                },
                {
                    slug: 'meallog-skipped-meals',
                    title: 'Παραλειπόμενα γεύματα',
                    body: 'Ποια γεύματα παραλείπει συχνότερα ο πελάτης βάσει της καταγραφής;',
                },
                {
                    slug: 'meallog-behavior-note',
                    title: 'Σχόλιο διατροφικής συμπεριφοράς',
                    body: 'Βάσει της καταγραφής γευμάτων, γράψε σχόλιο για τη διατροφική συμπεριφορά του πελάτη.',
                },
                {
                    slug: 'meallog-deviations',
                    title: 'Ανίχνευση παρεκκλίσεων',
                    body: 'Εντόπισε ημέρες που ο πελάτης ξέφυγε σημαντικά από το πλάνο: τι έτρωγε αντί γι’ αυτό;',
                },
                {
                    slug: 'meallog-protein-analysis',
                    title: 'Ανάλυση πρωτεΐνης',
                    body: 'Πληροί ο πελάτης τον ημερήσιο στόχο πρωτεΐνης βάσει της καταγραφής; Πού υστερεί;',
                },
                {
                    slug: 'meallog-peak-eating',
                    title: 'Πότε τρώει περισσότερο;',
                    body: 'Σε ποια ώρα/γεύμα της ημέρας καταναλώνει ο πελάτης τις περισσότερες θερμίδες;',
                },
                {
                    slug: 'meallog-week-compare',
                    title: 'Σύγκριση εβδομάδων',
                    body: 'Σύγκρινε την καταγραφή γευμάτων του πελάτη αυτή την εβδομάδα με την προηγούμενη: βελτίωση ή οπισθοδρόμηση;',
                },
                {
                    slug: 'meallog-real-vs-emotional',
                    title: 'Πραγματική vs συναισθηματική πείνα',
                    body: 'Με βάση την καταγραφή γευμάτων και συναισθημάτων του πελάτη, ξεχώρισε πότε τρώει από πραγματική και πότε από συναισθηματική πείνα.',
                },
                {
                    slug: 'meallog-emotional-patterns',
                    title: 'Μοτίβα συναισθηματικού φαγητού',
                    body: 'Ποια συναισθήματα συνδέονται πιο συχνά με τα γεύματα ή τα σνακ του πελάτη; (π.χ. άγχος, βαρεμάρα, χαρά)',
                },
                {
                    slug: 'meallog-overeating-triggers',
                    title: 'Triggers υπερφαγίας',
                    body: 'Εντόπισε με βάση τις καταγραφές ποια συναισθήματα ή ώρες προκαλούν υπερφαγία στον πελάτη.',
                },
                {
                    slug: 'meallog-mood-choices',
                    title: 'Σύνδεση διάθεσης-επιλογών',
                    body: 'Πώς αλλάζουν οι διατροφικές επιλογές του πελάτη ανάλογα με τη διάθεση που έχει καταγράψει;',
                },
                {
                    slug: 'meallog-emotional-strategies',
                    title: 'Πρόταση χειρισμού συναισθηματικής πείνας',
                    body: 'Με βάση τα μοτίβα συναισθηματικής πείνας του πελάτη, πρότεινε στρατηγικές να συζητήσω μαζί του/της στη συνεδρία.',
                },
            ],
        },

        dietPlan: {
            label: 'Διαιτολόγιο',
            items: [
                {
                    slug: 'dietplan-new-personalized',
                    title: 'Νέο εξατομικευμένο πλάνο',
                    preamble: 'Είσαι έμπειρος Διαιτολόγος-Διατροφολόγος.',
                    body: 'Δημιούργησε εξατομικευμένο διαιτολόγιο 7 ημερών, 5 γεύματα/ημέρα για τον πελάτη με τους εξής στόχους:\n• Ενέργεια: 2000 kcal ± 10%\n• Πρωτεΐνη: 120g ± 10%\n• Υδατάνθρακες: 45% ± 5%\n• Λίπος: 30% ± 5%\nΝα τηρούνται οι αντενδείξεις από το προφίλ του/της. Να υπάρχει ποικιλία γευμάτων ανά ημέρα. Μετά τη δημιουργία, κάνε έλεγχο ανά ημέρα και διόρθωσε αυτόματα όσες ημέρες βγαίνουν εκτός εύρους σε οποιοδήποτε μακροθρεπτικό.\nΘέλω στα πρωινά να βάζεις τουλάχιστον 3 διαφορετικές επιλογές. Στα κυρίως γεύματα μια κατανομή μεσογειακής διατροφής για το μεσημεριανό, και το βραδινό να είναι είτε ίδιο με το μεσημεριανό είτε κάτι ελαφρύ με τουλάχιστον 3 διαφορετικές επιλογές, προσαρμοσμένα όλα στις ανάγκες σε μακροθρεπτικά και ενέργεια. Μια καλή κατανομή στην εβδομάδα είναι κάθε μέρα να έχει βάση κοτόπουλο, όσπρια, λαδερά, κρέας, ψάρι, ζυμαρικά. Επίσης πρόσεξε να έχει σωστή κατανομή το κάθε γεύμα σε ενέργεια και μακροθρεπτικά: δεν γίνεται το ένα πρωινό να έχει 20 γρ πρωτεΐνη και το άλλο 10 γρ. Σε θέμα μακροθρεπτικών και ενέργειας, κάθε μεσημεριανό, πρωινό, ενδιάμεσο και βραδινό να έχει το πολύ 10% απόκλιση μεταξύ τους.',
                },
                {
                    slug: 'dietplan-conditions',
                    title: 'Πλάνο για παθήσεις',
                    body: 'Φτιάξε πλάνο 7 ημερών για τον πελάτη, κατάλληλο για υπερχοληστερολαιμία και αρτηριακή πίεση. Να τηρούνται οι αντενδείξεις από το προφίλ του/της. Να υπάρχει ποικιλία γευμάτων ανά ημέρα. Μετά τη δημιουργία, κάνε έλεγχο ανά ημέρα και διόρθωσε αυτόματα όσες ημέρες βγαίνουν εκτός εύρους σε οποιοδήποτε μακροθρεπτικό. Να υπάρχει ομοιομορφία στα μακροθρεπτικά κάθε γεύματος με μέγιστη απόκλιση ± 10% μεταξύ τους.',
                },
                {
                    slug: 'dietplan-trial-3day',
                    title: 'Δοκιμαστικό πλάνο 3 ημερών',
                    body: 'Δημιούργησε δοκιμαστικό πλάνο 3 ημερών με 4 γεύματα για τον πελάτη: 1800 kcal, 100-120γρ πρωτεΐνη. Μετά τη δημιουργία, κάνε έλεγχο ανά ημέρα και διόρθωσε αυτόματα όσες ημέρες βγαίνουν εκτός εύρους σε οποιοδήποτε μακροθρεπτικό.',
                },
                {
                    slug: 'dietplan-food-swap',
                    title: 'Αντικατάσταση τροφίμου',
                    body: 'Στο πλάνο του πελάτη, ποιο τρόφιμο να βάλω αντί για [τρόφιμο] με παρόμοιες θερμίδες και πρωτεΐνη;',
                },
                {
                    slug: 'dietplan-vegan',
                    title: 'Πλάνο για veggie / vegan',
                    body: 'Δημιούργησε εβδομαδιαίο vegan πλάνο για τον πελάτη με επαρκή πρωτεΐνη: 1800 kcal. Στα πρωινά βάλε τουλάχιστον 3 διαφορετικές επιλογές. Πρόσεξε να έχει σωστή κατανομή το κάθε γεύμα σε ενέργεια και μακροθρεπτικά: δεν γίνεται το ένα πρωινό να έχει 20 γρ πρωτεΐνη και το άλλο 10 γρ. Σε θέμα μακροθρεπτικών και ενέργειας, κάθε μεσημεριανό, πρωινό, ενδιάμεσο και βραδινό να έχει το πολύ 10% απόκλιση μεταξύ τους. Να τηρούνται οι αντενδείξεις από το προφίλ του/της. Να υπάρχει ποικιλία γευμάτων ανά ημέρα. Μετά τη δημιουργία, κάνε έλεγχο ανά ημέρα και διόρθωσε αυτόματα όσες ημέρες βγαίνουν εκτός εύρους σε οποιοδήποτε μακροθρεπτικό.',
                },
                {
                    slug: 'dietplan-preferences',
                    title: 'Πλάνο με βάση προτιμήσεις',
                    body: 'Φτιάξε πλάνο για τον πελάτη αξιοποιώντας τα τρόφιμα που έχει δηλώσει ότι του/της αρέσουν και αποφεύγοντας όσα αντιπαθεί. Να τηρούνται οι αντενδείξεις από το προφίλ του/της. Να υπάρχει ποικιλία γευμάτων ανά ημέρα. Μετά τη δημιουργία, κάνε έλεγχο ανά ημέρα και διόρθωσε αυτόματα όσες ημέρες βγαίνουν εκτός εύρους σε οποιοδήποτε μακροθρεπτικό.',
                },
                {
                    slug: 'dietplan-alternatives',
                    title: 'Εναλλακτικές για ισορροπία',
                    body: 'Στο πλάνο του πελάτη, δώσε μου 3 εναλλακτικές για κάθε γεύμα ώστε να μην βαρεθεί.',
                },
                {
                    slug: 'dietplan-personalized-full',
                    title: 'Εξατομικευμένο πλάνο (πλήρες)',
                    preamble: 'Είσαι έμπειρος Διαιτολόγος-Διατροφολόγος.',
                    body: 'Δημιούργησε εξατομικευμένο διαιτολόγιο 7 ημερών, 5 γεύματα ανά ημέρα, για τον πελάτη, χρησιμοποιώντας αποκλειστικά τρόφιμα από τη βάση δεδομένων.\n\nΣΤΟΧΟΙ ΗΜΕΡΑΣ\n• Ενέργεια: 2000 kcal ±10%\n• Πρωτεΐνη: 120 g ±10%\n• Υδατάνθρακες: 45% ±5%\n• Λίπος: 30% ±5%\n\nΥΠΟΧΡΕΩΤΙΚΟΙ ΠΕΡΙΟΡΙΣΜΟΙ\n1. Να λαμβάνονται υπόψη όλες οι αντενδείξεις, αλλεργίες, παθήσεις, φαρμακευτική αγωγή, διατροφικές προτιμήσεις και στόχοι από το προφίλ του πελάτη.\n2. Να υπάρχει ποικιλία γευμάτων και τροφίμων καθ’ όλη τη διάρκεια της εβδομάδας.\n3. Να ακολουθείται πρότυπο Μεσογειακής Διατροφής.\n4. Να αποφεύγεται η υπερβολική επανάληψη ίδιων γευμάτων.\n5. Να χρησιμοποιούνται ρεαλιστικές μερίδες και συνδυασμοί τροφίμων.\n6. Να χρησιμοποιούνται πραγματικά τρόφιμα από τη βάση δεδομένων και όχι σημειώσεις γευμάτων.\n\nΔΟΜΗ ΠΡΩΙΝΩΝ\nΝα δημιουργηθούν τουλάχιστον 3 διαφορετικοί τύποι πρωινού που θα εναλλάσσονται μέσα στην εβδομάδα.\n\nΚΑΤΑΝΟΜΗ ΚΥΡΙΩΝ ΓΕΥΜΑΤΩΝ ΕΒΔΟΜΑΔΑΣ\n• 2 ημέρες κοτόπουλο\n• 1 ημέρα ψάρι\n• 1 ημέρα όσπρια\n• 1 ημέρα λαδερό\n• 1 ημέρα κόκκινο κρέας\n• 1 ημέρα ζυμαρικό ή σύνθετο πιάτο με βάση δημητριακά\n\nΒΡΑΔΙΝΑ\nΤα βραδινά να είναι είτε παραλλαγή του μεσημεριανού είτε ελαφρύτερη εναλλακτική υψηλής πρωτεΐνης. Να υπάρχουν τουλάχιστον 3 διαφορετικοί τύποι βραδινού μέσα στην εβδομάδα.\n\nΟΜΟΙΟΜΟΡΦΙΑ ΓΕΥΜΑΤΩΝ\nΗ κατανομή ενέργειας και μακροθρεπτικών μεταξύ αντίστοιχων γευμάτων πρέπει να είναι σταθερή, με μέγιστη επιτρεπτή απόκλιση ±10% μεταξύ όλων των γευμάτων.\nΠαράδειγμα: αν ένα πρωινό παρέχει 20g πρωτεΐνης, κανένα άλλο πρωινό δεν επιτρέπεται να παρέχει λιγότερο από 18g ή περισσότερο από 22g.\n\nΕΝΔΕΙΚΤΙΚΗ ΚΑΤΑΝΟΜΗ ΕΝΕΡΓΕΙΑΣ ΑΝΑ ΓΕΥΜΑ\n• Πρωινό: 25% της ημερήσιας ενέργειας\n• Δεκατιανό: 10%\n• Μεσημεριανό: 30%\n• Απογευματινό: 10%\n• Βραδινό: 25%\nΗ ίδια λογική να εφαρμόζεται και στα μακροθρεπτικά συστατικά.\n\nΥΠΟΧΡΕΩΤΙΚΟΣ ΕΛΕΓΧΟΣ ΠΟΙΟΤΗΤΑΣ\nΜετά τη δημιουργία του διαιτολογίου:\n1. Υπολόγισε για κάθε ημέρα: kcal, πρωτεΐνη, υδατάνθρακες, λίπος.\n2. Σύγκρινε τα αποτελέσματα με τους στόχους.\n3. Αν οποιαδήποτε ημέρα βρίσκεται εκτός στόχων: τροποποίησε αυτόματα ποσότητες ή τρόφιμα, επανυπολόγισε και επανέλεγξε.\n4. Επανέλαβε τη διαδικασία μέχρι όλες οι ημέρες να βρίσκονται εντός των στόχων.',
                },
            ],
        },

        athleteList: {
            label: 'Λίστα πελατών',
            items: [],
        },

        generic: {
            label: '',
            items: [],
        },
    },
};
